import $ from 'jquery';

/**
 * Requests an animation frame.
 *
 * @param callback
 * @returns {*}
 */
export function frame(callback) {
	if (typeof requestAnimationFrame === 'undefined') {
        return setTimeout(callback, 0);
    }
    return requestAnimationFrame(callback);
}

/**
 * Cancels a frame request.
 *
 * @param id
 */
export function unframe(id) {
    if (typeof cancelAnimationFrame === 'undefined') {
        return clearTimeout(id);
    }
    return cancelAnimationFrame(id);
}

/**
 * Triggers a layout reflow for a specific element.
 *
 * @param element
 */
export function redraw(element) {
    if (element instanceof $) {
        element = element[0];
    }
    // Accessing this property triggers a layout reflow
    element.offsetWidth;
}



// WEBPACK FOOTER //
// ./source/scripts/utils/drawing.js